<script setup>
import { onMounted, ref, computed } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

const props = defineProps({
  type: String,
});

const classes = computed(() =>
  props.type === "close"
    ? "px-7 py-3 text-xl text-gray-500 bg-transparent hover:bg-gray-200 border border-gray-500 rounded-lg"
    : "px-20 py-3 text-xl font-semibold rounded-lg text-white bg-oteo-300 hover:opacity-70"
);
</script>

<template>
  <Link :class="classes">
    <slot />
  </Link>
</template>
